// socket.js
import io from "socket.io-client";
import metaData from "../data/metaData";
// prevent connect now, call socket.connect() after loggedIn
const socket = io(metaData.serverURL, {
  autoConnect: false,
});
export default socket;
